import { postJson } from './httpClient';

/**
 * Create order via DinDin web API (authenticated customer).
 * Route: POST .../dindin-web/place-order (Bearer Sanctum token).
 *
 * @param {Record<string, unknown>} payload - From buildWebOrderPayload()
 * @param {string} token - Customer Bearer token
 * @param {RequestInit} [fetchInit]
 * @returns {Promise<{ order?: object }>}
 */
export async function createWebOrder(payload, token, fetchInit = {}) {
  const t = String(token || '').trim();
  if (!t) throw new Error('Not signed in');

  const json = await postJson('/place-order', {
    body: payload,
    token: t,
    globalLoading: false,
    ...fetchInit,
  });

  if (!json?.success) {
    const msg = String(json?.message || 'Could not place order');
    if (/POST method is not supported/i.test(msg)) {
      throw new Error(
        'Order API is not available on this server. Deploy the latest pos_temp backend (POST /dindin-web/place-order) or use local API via npm start.',
      );
    }
    throw new Error(msg);
  }

  return json?.data ?? {};
}
